import React from "react";
import IdView from "../../../../components/id-view";
import { Partner } from "../../../../api/staff";

interface PartnerIdCellProps {
  partner: Partner;
}

/**
 * PartnerIdCell Component
 *
 * Displays partner ID with copy functionality
 */
const PartnerIdCell: React.FC<PartnerIdCellProps> = ({ partner }) => {
  return (
    <div className="py-[8px]">
      <IdView textToCopy={partner.id}>
        {partner.id.slice(-4)}
      </IdView>
    </div>
  );
};

export default PartnerIdCell;
